<template>
  <div class="j-dict-select-tag">
    <a-radio-group
      v-if="tagType == 'radio'"
      @change="handleInput"
      :value="getValueSting"
      :disabled="disabled"
    >
      <a-radio v-for="(item, key) in mergedOptions" :key="key" :value="item.value">
        {{ item.text }}
      </a-radio>
    </a-radio-group>

    <a-radio-group
      v-else-if="tagType == 'radioButton'"
      buttonStyle="solid"
      @change="handleInput"
      :value="getValueSting"
      :disabled="disabled"
    >
      <a-radio-button v-for="(item, key) in mergedOptions" :key="key" :value="item.value">
        {{ item.text }}
      </a-radio-button>
    </a-radio-group>
    <a-select
      v-else-if="tagType == 'select'"
      :getPopupContainer="getPopupContainer"
      :placeholder="placeholder"
      :disabled="disabled"
      :showSearch="isShowSearch"
      :filterOption="handleFilterOption"
      :value="getValueSting"
      :mode="mode"
      @select="handleSelect"
      @change="handleInput"
      :allowClear="allowClear"
      style="width: 100%"
    >
      <a-select-option v-if="isShowEmpty && mode === 'default'" :value="undefined">请选择</a-select-option>
      <a-select-option v-for="(item, key) in mergedOptions" :key="key" :value="item.value">
        <span style="display: inline-block; width: 100%" :title="item.text || item.label">
          {{ item.text || item.label }}
        </span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import Vue from 'vue'
import { ajaxGetDictItems, getDictItemsFromCache } from '@/api/api'
import { CURR_GRADECLASS } from '@/store/mutation-types'

export default {
  name: 'JDictSelectTag',
  props: {
    dictCode: String,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number, Array],
    type: String,
    getPopupContainer: {
      type: Function,
      default: (node) => node.parentNode,
    },
    isShowSearch:{
      type: Boolean,
      default:false,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    isShowEmpty: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: 'default',
    },
    identityGet: {
      type: String,
      default: '',
    },
    optionalVals: {
      type: String,
      default: '',
    },
    extraOptions: {
      type: Array,
      default: () => []
    },
    isDefaultValue:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dictOptions: [],
      tagType: '',
    }
  },
  watch: {
    dictCode: {
      immediate: true,
      handler() {
        this.initDictData()
      },
    },
    identityGet: {
      handler() {
        this.initDictData()
      },
      immediate: true,
    },
  },
  created() {
    // console.log(this.dictCode);
    if (!this.type || this.type === 'list') {
      this.tagType = 'select'
    } else {
      this.tagType = this.type
    }
    //获取字典数据
    // this.initDictData();
  },
  computed: {
    getValueSting() {
      // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      // 当有null或“” placeholder不显示
      // console.log('this.value', this.value)

      if (this.mode != 'multiple') {
        return this.value != null ? this.value.toString() : undefined
      }
      return this.value || []
      // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
    },
    // 合并选项
    mergedOptions() {
      return [...this.extraOptions, ...this.dictOptions];
    }
  },
  methods: {
    handleFilterOption(input, option) {
      // 递归提取 VNode 中的文本内容，解决 option 内嵌套 span 导致默认搜索报错的问题
      const getText = (vnode) => {
        if (!vnode) return ''
        if (vnode.text) return vnode.text
        if (vnode.children && Array.isArray(vnode.children)) {
          return vnode.children.map((child) => getText(child)).join('')
        }
        return ''
      }
      const children = option.componentOptions ? option.componentOptions.children : []
      const optionText = children.map((child) => getText(child)).join('')
      return optionText.toLowerCase().includes(input.toLowerCase())
    },
    initDictData() {
      // 从身份缓存获取信息
      if (this.identityGet.includes('gradeDict') || this.identityGet.includes('classDict')) {
        const keys = this.identityGet.split(',')
        let currOptions = Vue.ls.get(CURR_GRADECLASS)[keys[0]]
        // console.log("currOptions--------------",currOptions)
        if (currOptions.length) {
          currOptions = currOptions.map((item) => ({
            ...item,
            text: item.name,
            title: item.name,
            value: item.id,
          }))
        }
        if (keys[1]) {
          currOptions = currOptions.filter((item) => item.gradeId == keys[1])
        }
        // console.log("optionalVals--------------",this.optionalVals)
        if (this.optionalVals?.length) {
          // console.log("--------------")
          const optionalVals = this.optionalVals?.split(',')
          currOptions = currOptions.filter((item) => optionalVals.includes(item.value))
        }
        this.dictOptions = currOptions || []
        this.$emit('setDefaultValue', this.dictOptions)
        return
      }
      //优先从缓存中读取字典配置
      if (getDictItemsFromCache(this.dictCode)) {
        this.dictOptions = getDictItemsFromCache(this.dictCode)
        return
      }

      //根据字典Code, 初始化字典数组
      if (!this.dictCode) {
        return
      }
      ajaxGetDictItems(this.dictCode, null).then((res) => {
        if (res.success) {
          this.dictOptions = res.result
        }
      })
    },
    handleInput(e) {
      
      let val
      if (this.tagType == 'radio') {
        val = e.target.value
      } else {
        val = e
      }
      if (val === undefined) {
        this.$emit('clear')
      }
      if (this.triggerChange) {
        this.$emit('change', val)
      } else {
        this.$emit('input', val)
      }
    },
    handleSelect(val) {
      if (this.mode == 'default') {
        const currOption = this.dictOptions.find((item) => item.value === val)
        this.$emit('select', currOption)
      } else {
        this.$emit('select', val)
      }
    },
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    },
  },
}
</script>

<style scoped lang="less">
.j-dict-select-tag {
  display: inline-block;
  position: relative;
  width: 100%;
}
</style>
